import getSliceName from '@om-fe/core/utils/get-slice-name';
import {
    TOURNAMENT_MATCH_AGGREGATOR_PATH,
    TOURNAMENT_GROUPS_MATCH_AGGREGATOR_PATH,
    TOURNAMENT_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH,
    TournamentMatchListTopic,
    TournamentGroupsMatchListTopic,
    TournamentGroupsOverviewMatchListTopic,
    slicePrefix,
} from './tournament-match-list.constants';
import { getMatchListNrOfMarkets } from '../../utils/match-list.utils';
import { TournamentMatchListPublicProps } from './tournament-match-list';
import * as shallowEqual from 'shallowequal';
import { DisciplineLiveStatus } from '@om-fe/models';

export function getTournamentMatchListSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

export function getTournamentGroupsMatchListSliceName(instanceId: string): string {
    return getSliceName(`${slicePrefix}-group`, instanceId);
}

export function getTournamentMatchListTopic(
    tournamentId: string,
    liveStatus: DisciplineLiveStatus,
    isDefault?: boolean,
    mainMarketsLimit?: number,
    isAuthenForTopic?: boolean,
): TournamentMatchListTopic {

    let topic: string = TOURNAMENT_MATCH_AGGREGATOR_PATH;
    topic = !isDefault ? `${topic}/default-event-info` : topic;
    topic = isAuthenForTopic ? `${topic}/logged-in-users` : topic;
    topic = `${topic}/:liveStatus/:nrOfMarkets`;

    const nrOfMarkets: number = getMatchListNrOfMarkets(mainMarketsLimit);

    return {
        path: topic,
        params: {
            tournamentId,
            nrOfMarkets,
            liveStatus,
        },
    };
}

export function getTournamentGroupsMatchListTopic(
    tournamentId: string,
    liveStatus: DisciplineLiveStatus,
    groupsLimit: number,
    isAuthenForTopic?: boolean,
): TournamentGroupsMatchListTopic {

    let topic: string = TOURNAMENT_GROUPS_MATCH_AGGREGATOR_PATH;
    topic = isAuthenForTopic ? `${topic}/logged-in-users` : topic;
    topic = `${topic}/:groupsLimit/:liveStatus`;

    return {
        path: topic,
        params: {
            tournamentId,
            groupsLimit,
            liveStatus,
        },
    };
}

export function getTournamentGroupsOverviewMatchListTopic(
    tournamentId: string,
    liveStatus: DisciplineLiveStatus,
    marketGroupsOverviewIds: string,
    isDefault?: boolean,
    extraParam?: string,
    isAuthenForTopic?: boolean,
): TournamentGroupsOverviewMatchListTopic {

    let topic: string = TOURNAMENT_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH;
    topic = !isDefault ? `${topic}/default-event-info` : topic;
    topic = isAuthenForTopic ? `${topic}/logged-in-users` : topic;
    topic = `${topic}/:liveStatus/:marketGroupsOverviewIds`;
    topic = extraParam ? `${topic}/:extraParam` : topic;

    return {
        path: topic,
        params: {
            tournamentId,
            liveStatus,
            marketGroupsOverviewIds,
            extraParam,
        },
    };
}

interface TournamentMatchListTopicProps {
    readonly tournamentId: string;
    readonly mainMarketsLimit: number | undefined;
    readonly isDefault: boolean | undefined;
    readonly liveStatus: DisciplineLiveStatus;
}

const getTopicProps = (props: TournamentMatchListPublicProps): TournamentMatchListTopicProps => ({
    tournamentId: props.tournamentId,
    mainMarketsLimit: props.mainMarketsLimit,
    isDefault: props.isDefault,
    liveStatus: props.liveStatus,
});

export function areTournamentMatchListTopicPropsEqual(
    prevProps: TournamentMatchListPublicProps,
    newProps: TournamentMatchListPublicProps,
): boolean {
    return shallowEqual(getTopicProps(prevProps), getTopicProps(newProps));
}
